import type { ReactElement } from 'react'
import type { DeviceType } from '~/types/device-type'

import { PlatformIcon } from '~/components/AppLogo'

import './styles.scss'

const AppSelectorTooltipOverlay = ({ deviceType, label }: { deviceType: DeviceType; label: string }): ReactElement => {
  return (
    <div className="app-selector-tooltip-overlay">
      <div>{label}</div>
      <div className="app-selector-tooltip-overlay__platform-icon-wrapper">
        <PlatformIcon appPlatform={deviceType} size="small" />
      </div>
    </div>
  )
}

export default AppSelectorTooltipOverlay
